import script from "./DrawerForm.vue?vue&type=script&setup=true&lang=js"
export * from "./DrawerForm.vue?vue&type=script&setup=true&lang=js"

import "./DrawerForm.vue?vue&type=style&index=0&id=6f416fa6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f416fa6"]])

export default __exports__